import React from "react";
import FormSelectCheckbox, { FormSelectCheckboxProps } from "ui/Form/SelectCheckbox/SelectCheckbox";

import { Field, UseFieldConfig } from "react-final-form";

type Props = FormSelectCheckboxProps & UseFieldConfig<string>;

const SelectCheckboxField: React.FC<Props> = ({
    labelProps,
    fieldGroupProps,
    fieldControlProps,
    adornmentStart,
    adornmentEnd,
    inputProps,
    listHeader,
    adormentRight,
    ...fieldProps
}) => {
    return (
        <Field name={inputProps.name} {...fieldProps}>
            {({ input, meta }) => {
                return (
                    <FormSelectCheckbox
                        error={!!(meta.error || meta.submitError)}
                        errorMessage={meta.error || meta.submitError}
                        labelProps={labelProps}
                        fieldGroupProps={fieldGroupProps}
                        fieldControlProps={fieldControlProps}
                        adornmentStart={adornmentStart}
                        adornmentEnd={adornmentEnd}
                        inputProps={Object.assign({}, input, inputProps)}
                        listHeader={listHeader}
                        adormentRight={adormentRight}
                        {...fieldProps}
                    />
                );
            }}
        </Field>
    );
};

export default SelectCheckboxField;
